import { FC } from "react";

export const Input: FC<{ type: string, value: any, onChange?: Function }> = props =>
{
  const { type, value, onChange } = props;

  return <input type={ type } value={ value } onChange={ (e) => onChange(e.target.value) } className="w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-sky-500 text-sm leading-6 outline-none px-3" />;
};